export function fixImageSizeForIE() {
    const _window = this._window;
    const _document = this._document;

    _window.addEventListener("load", () => {
        const images = _document.querySelectorAll("img[sizes]");

        for(const img of images) {
            const sources = img.getAttribute("srcset").split(", ");
            const source = sources[sources.length - 1].split(" ")[0];
            img.src = source;
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/fix-image-size-for-ie.js